import { render } from "./WhoToFollowBlock.vue?vue&type=template&id=4a71e312"
const script = {}
script.render = render

export default script